import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { gr } from "../tokens";

// Page content box: its edges line up with the top bar, so a page title starts under the greeting
// and the right-most control / card ends under the profile button.
// Phones 16 / tablets 24 = the top bar's side padding. Large screens (sidebar open): the main area
// already has 16 on each side; the top bar has 32 and the greeting sits 8 further in, so the page
// adds 24 on the left (32 + 8 − 16) and 16 on the right (32 − 16).
// Use it instead of the legacy bootstrap `.container-fluid` (15px) on redesigned pages.
export default function GrPage({ as = "div", children, sx, ...rest }) {
  return (
    <Box
      component={as}
      sx={{
        minWidth: 0,
        // Theme breakpoints, the same ones the top bar and the main area switch on.
        pl: { xs: gr.space[4], sm: gr.space[6] },
        pr: { xs: gr.space[4], sm: gr.space[6], lg: gr.space[4] },
        // Space under the top bar. With the page title's line box (and a 40px button beside it) the
        // visible gap reads the same as the side gutter: ~16 on phones, ~24 on larger screens.
        pt: { xs: gr.space[3], sm: gr.space[4] },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

GrPage.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.object,
};
